module.exports = __webpack_public_path__ + "static/media/pallaBlu.8af58a83.svg";